import { jstimestamp_2_julian_datetime } from "../calendar/conversion";

const tick_handlers: ((date: number) => void)[] = [];
let interval: number;
let onAdded: () => void;
let julianNow = function () {
	return jstimestamp_2_julian_datetime(Date.now());
};

function doTickHandlersLoop() {
	const julian_now = julianNow();
	for (let i = 0; i < tick_handlers.length; i += 1) {
		tick_handlers[i](julian_now);
	}
	interval = setTimeout(doTickHandlersLoop, 500);
}
function startWhenAdded() {
	interval = setTimeout(doTickHandlersLoop, 500);
	onAdded = () => {
		//noop
	};
}
function stopWhenRemoved() {
	clearInterval(interval);
	onAdded = startWhenAdded;
}
onAdded = startWhenAdded;

export default {
	on: function (type: "tick", callback: (time: number) => void): void {
		switch (type) {
			case "tick":
				tick_handlers.push(callback);
				onAdded();
				break;
			default:
				throw new Error("unsupported clock event type " + type);
		}
	},
	off: function (type: "tick", callback: (time: number) => void): void {
		switch (type) {
			case "tick":
				tick_handlers.splice(tick_handlers.indexOf(callback), 1);
				if (tick_handlers.length <= 0) {
					stopWhenRemoved();
				}
				break;
			default:
				throw new Error("unsupported clock event type " + type);
		}
	},
	getNow: function (): number {
		return julianNow();
	},
	setNowFunction: function (nowFunction: () => number): void {
		julianNow = nowFunction;
	},
};
